import React from "react";
import InputHLPure from "../inputHL/inputHL.pure";
import "./inputLogicHLPure.css";

const InputLogicHLPure = (props) => {
    let { 
        labelInput,
        typeInput,
        handleChangeInput,
        valueInput,
        inputActive
    } = props

    return (
        <div className="inputLogicHLPure-container">
            <InputHLPure
                {...props}
                labelInput={labelInput}
                typeInput={typeInput}
                handleChangeInput={handleChangeInput}
                valueInput={valueInput}
                inputActive={inputActive}
            />
        </div>
    );
};

export { InputLogicHLPure as default }